import { render } from "./EditingTracks.vue?vue&type=template&id=61d22f1f"
import script from "./EditingTracks.vue?vue&type=script&lang=js"
export * from "./EditingTracks.vue?vue&type=script&lang=js"
script.render = render

export default script